import React, { memo, useCallback, useMemo } from 'react';

import Select from 'containers/components/Fields/Select';

const EMPTY_OPTIONS = [];

const AssignmentField = memo(({ changeField, data, errors, field, getError }) => {
    const { id, inputAttrs, hidden, label, mandatory, readOnly } = field;
    const options = inputAttrs?.options || EMPTY_OPTIONS;

    // Transform value: teamaggregated is displayed as 'team' in the select
    const value = useMemo(() => {
        const { assignment } = data;
        if (!assignment) return undefined;

        const displayValue = assignment === 'teamaggregated' ? 'team' : assignment;
        const option = options.find((opt) => opt.value === displayValue);

        return option || { value: displayValue, label: displayValue };
    }, [data, options]);

    const error = useMemo(() => getError(errors[id]), [errors, getError, id]);

    const handleChange = useCallback(
        (newValue) => {
            changeField(id)(newValue?.value || null);
        },
        [changeField, id],
    );

    const selectProps = useMemo(
        () => ({
            error,
            isClearable: false,
            label,
            labelMode: 'horizontal',
            mandatory,
            onChange: handleChange,
            options,
            readOnly,
            value,
        }),
        [error, handleChange, label, mandatory, options, readOnly, value],
    );

    if (hidden) return null;

    return (
        <div className="fm-assignment-field">
            <Select {...selectProps} />
        </div>
    );
});

AssignmentField.displayName = 'AssignmentField';

export default AssignmentField;
